import React, { useEffect, useState } from "react";
import ModelView1 from "../TableModel/View/ModelView1";
import ModelView2 from "../TableModel/View/ModelView2";
import useFormsFormulaStore from "../../../store/zustandStore/formsFormulaZs";
import ModelView3 from "../TableModel/View/ModelView3";
import authHeader from "../../../services/auth-header";
import { APP_URL } from "../../../services/http-common";
import axios from "axios";
import ModelViewListSimple from "../TableModel/View/ModelViewListSimple";
import ModelViewListOshma from "../TableModel/View/ModelViewListOshma";
import ModelViewReklmaSekonda from "../TableModel/View/ModelViewReklmaSekonda";
import ModelViewTextDotValue from "../TableModel/View/ModelViewTextDotValue";
import ModelViewShareholding from "../TableModel/View/ModelViewShareholding";
import ModelViewProgramList from "../TableModel/View/ModelViewProgramList";
import ModelViewPopullata from "../TableModel/View/ModelViewPopullata";
import ModelViewShtojca1 from "../TableModel/View/ModelViewShtojca1";
import ModelViewReklamaBleresit from "../TableModel/View/ModelViewReklamaBleresit";
import ModelViewVleresimGjinor1 from "../TableModel/View/ModelViewVleresimGjinor1";
import ModelViewVleresimGjinor2 from "../TableModel/View/ModelViewVleresimGjinor2";
import ModelViewShtojca2 from "../TableModel/View/ModelViewShtojca2";
import ModelViewShtojca3 from "../TableModel/View/ModelViewShtojca3";
import ModelViewShtojca4 from "../TableModel/View/ModelViewShtojca4";

export const TableSwitchView = ({ data }) => {
  const {
    tableHeaders,
    tableContent,
    tableSetting,
    customTableHeader,
    formId,
    year = 2024,
    formulaId,
    formFormulaType,
    postProcessing,
    apiEndpoint,
  } = data;

  const [dataFromApi, setDataFromApi] = useState(null);

  const { getEvaluateFormFormulaZs } = useFormsFormulaStore();

  useEffect(() => {
    if (formulaId !== "" && formulaId !== apiEndpoint) {
      const fetchData = async () => {
        if (formFormulaType === "API") {
          try {
            const response = await axios.get(APP_URL + apiEndpoint, {
              headers: authHeader(),
            });

            if (
              postProcessing &&
              postProcessing !== "string" &&
              postProcessing !== null &&
              postProcessing !== undefined &&
              postProcessing !== ""
            ) {
              let groupByType;
              try {
                groupByType = eval(`(${postProcessing})`);

                setDataFromApi(groupByType(response.data));
                return groupByType(response.data);
                // return groupByType(response.data) ?? {};
              } catch (err) {
                console.error("Eval failed:", err);
                return err; // stop execution
              }
            }
            setDataFromApi(response?.data?.content);
            return response?.data?.content;
          } catch (error) {
            console.error("Error fetching items", error);
            const message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        } else {
          try {
            const selected = { formulaId: formulaId, year: year };
            const response = await getEvaluateFormFormulaZs(selected);

            if (response?.all) {
              setDataFromApi(response?.all);
            } else {
              if (response?.data) {
                setDataFromApi(response?.data);
              } else {
                setDataFromApi(response);
              }
            }
          } catch (error) {}
        }
      };
      fetchData();
    }
  }, [formulaId]);

  return (
    <div>
      {dataFromApi !== null &&
        (() => {
          switch (tableSetting?.model?.id) {
            case "model-1":
              return (
                <ModelView1
                  tableHeaders={tableHeaders}
                  tableContent={tableContent ?? dataFromApi}
                  customHeader={customTableHeader}
                />
              );
            case "model-2":
              return (
                <ModelView2
                  tableHeaders={tableHeaders}
                  tableContent={tableContent}
                />
              );
            case "model-3":
              return (
                <ModelView3
                  tableHeaders={tableHeaders}
                  tableContent={dataFromApi}
                />
              );
            case "model-list-oshma":
              return (
                <ModelViewListOshma
                  tableHeaders={tableHeaders}
                  tableContent={dataFromApi}
                />
              );
            case "model-reklama-sekonda":
              return (
                <ModelViewReklmaSekonda
                  tableHeaders={tableHeaders}
                  tableContent={dataFromApi}
                />
              );
            case "model-text-dot-value":
              return <ModelViewTextDotValue data={dataFromApi} />;
            case "model-shareholding":
              return <ModelViewShareholding tableContent={dataFromApi} />;
            case "model-program-list":
              return <ModelViewProgramList tableContent={dataFromApi} />;
            case "model-popullata":
              return <ModelViewPopullata tableContent={dataFromApi} />;
            case "model-shtojca-1":
              return <ModelViewShtojca1 tableContent={dataFromApi} />;
            case "model-shtojca-2":
              return <ModelViewShtojca2 tableContent={dataFromApi} />;
            case "model-shtojca-3":
              return <ModelViewShtojca3 tableContent={dataFromApi} />;
            case "model-shtojca-4":
              return <ModelViewShtojca4 tableContent={dataFromApi} />;
            case "model-reklama-bleresit":
              return <ModelViewReklamaBleresit tableContent={dataFromApi} />;
            case "model-vleresim-gjinor-1":
              return <ModelViewVleresimGjinor1 tableContent={dataFromApi} />;
            case "model-vleresim-gjinor-2":
              return <ModelViewVleresimGjinor2 tableContent={dataFromApi} />;

            default:
              return null;
          }
        })()}
    </div>
  );
};
